/* eslint-disable prettier/prettier */
import { LegacyDepartmentEntity } from './../../types/smart-client/legacy-department-allowed.type';
import { LegacyProjectEntity } from './../../types/smart-client/legacy-project-allowed.type';
import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AllowedProjectsDepartmentsService {
  private readonly _projects = signal<LegacyProjectEntity[]>([]);
  private readonly _departments = signal<LegacyDepartmentEntity[]>([]);

  readonly projects = this._projects.asReadonly();
  readonly departments = this._departments.asReadonly();

  readonly projectCodes = computed(() => this._projects().map(p => p.code));
  readonly departmentCodes = computed(() => this._departments().map(d => d.code));
  readonly departmentNames = computed(() => this._departments().map(d => d.name));

  setProjects(projects: LegacyProjectEntity[]): void {
    this._projects.set(projects);
  }

  setDepartments(departments: LegacyDepartmentEntity[]): void {
    this._departments.set(departments);
  }
}
